import React from 'react';
import { iconForKey } from '@/components/icons/registry';
import {
  AimOutlined,
  AppstoreOutlined,
  BarChartOutlined,
  FileTextOutlined,
  NodeIndexOutlined,
  RobotFilled,
  RobotOutlined,
  ThunderboltOutlined,
} from '@ant-design/icons';
const ICON_BY_CAPABILITY = new Map([
  ['auto', RobotOutlined],
  ['expert', RobotFilled],
  ['domain_flow', ThunderboltOutlined],
  ['requirement_intake', NodeIndexOutlined],
  ['intelligent_sourcing', AimOutlined],
  ['analysis_mode', BarChartOutlined],
  ['document_processing', FileTextOutlined],
]);

export const resolveCapabilityModeIcon = (capabilityId) => {
  const Icon = ICON_BY_CAPABILITY.get(String(capabilityId || '').trim()) || AppstoreOutlined;
  return <Icon />;
};

const resolveConfiguredIcon = (item) => {
  const Icon = iconForKey(String(item?.icon_key || '').trim());
  return <Icon />;
};

export const resolveSkillIcon = (item) => resolveConfiguredIcon(item);

export const resolveArtifactSkillIcon = (artifactType, projection = {}) => {
  const declarations = Array.isArray(projection.skills) ? projection.skills : [];
  const owners = new Map(declarations
    .filter(item => item?.target_type === 'skill' && item.registered === true && item.target_id
      && Array.isArray(item.artifact_types) && item.artifact_types.includes(artifactType))
    .map(item => [item.target_id, item]));
  return owners.size === 1 ? resolveSkillIcon(owners.values().next().value) : <FileTextOutlined />;
};

export const resolveCapabilityIcon = (item) => resolveConfiguredIcon(item);
